export default {
  title: 'Renseignements personnels',
  save: 'Enregistrer',
  cancelMessageButton: 'Annuler',
  aboutYouLabel: 'À propos de vous',
  correspondence: {
    title: 'Correspondance',
    label: 'Langue de correspondance',
    french: 'Français',
    english: 'Anglais',
  },
  emails: {
    title: 'Courriel',
    homeLabel: 'Courriel principal',
    homeConfirmLabel: 'Confirmation du courriel principal',
    workLabel: 'Courriel secondaire (facultatif)',
    workConfirmLabel: 'Confirmation du courriel secondaire (facultatif)',
    emailConfirmation: 'Les 2 adresses courriel doivent être identiques',
  },
  phones: {
    title: 'Téléphone',
    workPhoneLabel: 'Téléphone travail (facultatif)',
    homePhoneLabel: 'Téléphone maison',
    cellPhoneLabel: 'Cellulaire (facultatif)',
    faxPhoneLabel: 'Télécopieur (facultatif)',
    extentionPhoneLabel: 'Poste ',
    extentionValidation: 'Le format de l\'extension doit être un nombre entre 1 et 4 chiffres.',
  },
  address: {
    title: 'Adresse',
    newAdressLabel: 'Nouvelle adresse',
    messageText: 'Pour modifier votre adresse, veuillez communiquer avec nous au',
    apartment: 'Appartement',
    office: 'Bureau',
    postalBox: 'Casier postal',
    ruralRoute: 'Route rurale',
    none: 'Aucun',
    countryCA: 'Canada',
    countryUS: 'États-Unis',
  },
};
